import { Box, Stack } from "@mui/material";
import { environmentConfig } from "@src/appV2/environment";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { Text, Title } from "@src/appV2/redesign/system/ui-components";

const SAMPLE_BADGE_IMAGE_URL = `${environmentConfig.REACT_APP_PUBLIC_ASSETS_BASE_URL}/images/badge-policy/idealBadgeSelfie.png`;

interface BadgeVerificationResultStepProps {
  isMarkingAsSeen: boolean;
  onGetNewBadge: () => void;
  onAcknowledge: () => void;
}

export function BadgeVerificationResultStep(props: BadgeVerificationResultStepProps) {
  const { isMarkingAsSeen, onGetNewBadge, onAcknowledge } = props;

  return (
    <>
      <Stack spacing={8} sx={{ paddingX: 5, paddingBottom: 2 }}>
        <Stack alignItems="center" textAlign="center">
          <Title
            variant="h4"
            component="h2"
            sx={(theme) => ({ color: theme.palette.text.primary })}
          >
            Verify your badge like this
          </Title>
        </Stack>

        <Stack alignItems="center" spacing={8}>
          <Box
            component="img"
            src={SAMPLE_BADGE_IMAGE_URL}
            alt="Example of a worker wearing a badge"
            sx={(theme) => ({
              width: "100%",
              maxWidth: 280,
              height: 280,
              objectFit: "cover",
              objectPosition: "center bottom",
              borderRadius: theme.borderRadius?.xSmall,
            })}
          />

          <Text
            variant="body1"
            color={(theme) => theme.palette.text.primary}
            sx={{ textAlign: "center" }}
          >
            For your next shift, wear your badge on top of your work attire with your name and role
            displayed
          </Text>
        </Stack>
      </Stack>

      <DialogFooter orientation="vertical">
        <LoadingButton
          fullWidth
          variant="contained"
          size="large"
          isLoading={isMarkingAsSeen}
          onClick={onAcknowledge}
        >
          Okay
        </LoadingButton>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          disabled={isMarkingAsSeen}
          onClick={onGetNewBadge}
        >
          Get a new badge
        </Button>
      </DialogFooter>
    </>
  );
}
